import styled from "styled-components";

const Step = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  margin: 5px 0;

  & h4 {
    font-size: 14px;
    font-weight: 700;
    margin: 0;
  }

  .step__img-container {
    width: 30px;
    height: 30px;
    margin-right: 10px;
    & img {
      width: 100%;
      height: 100%;
    }
  }
`;

const ResetInstructionStep = ({ img, text }) => {
  return (
    <Step>
      <div className="step__img-container">
        <img className="numberImg" src={img} alt="3-icon" />
      </div>
      <h4>{text}</h4>
    </Step>
  );
};

export default ResetInstructionStep;
